export const initialState = {
  loggedIn: false,
};

const userReducer = (state, action) => {
  const { type, payload } = action;
  let newState = { ...state };

  switch (type) {
    case "CHANGE_LOGIN_STATE":
      return {
        ...newState,
        loggedIn: payload.loggedIn,
      };
    default:
      return newState;
  }
};

export default userReducer;